<template>
    <header class="navbar" v-click-outside="closeDropdowns">
        <div class="navbar-container">
            <div class="navbar-wrapper">
                <div class="navbar-toggle" @click.stop="toggleSidebar">
                    <svg-icon icon="bars-solid" class="cursor-pointer"></svg-icon>
                </div>
                <router-link to="/painel-administrativo" class="navbar-breadcrumb"
                             v-if="$store.getters['user/getUser']['tipo'] !== 2">Painel
                    Administrativo
                </router-link>
                <router-link to="/painel-administrativo" class="navbar-breadcrumb"
                             v-if="$store.getters['user/getUser']['tipo'] === 2">Lista de Eventos
                </router-link>
            </div>
            <button class="block lg:hidden focus:outline-none" @click="toggleCollapse">
                <svg-icon icon="ellipsis-v-solid"></svg-icon>
            </button>
            <div class="navbar-collapse" :class="{collapsed:collapse}">
                <div class="navbar-profile">
                    {{ $store.getters['user/getUser'].nome }}
                    <button class="navbar-profile-button" @click="toggleDropdown('profile')">
                        <svg-icon icon="chevron-down-light"
                                  class="navbar-profile-chevron"></svg-icon>
                    </button>
                    <transition name="custom-classes-transition"
                                enter-active-class="animate__animated animate__zoomIn"
                                leave-active-class="animate__animated animate__zoomOut">
                        <ul class="navbar-profile-links" v-if="dropdowns.profile">
                            <li class="divider"></li>
                            <li class="nav-link text-center text-gray-800">
                                <a class="cursor-pointer" @click="logout">
                                    <div class="flex justify-center items-center">
                                        <svg-icon icon="exit"
                                                  class="cursor-pointer text-primary mr-2"/>
                                        Sair do Sistema
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </transition>
                </div>
            </div>
        </div>

    </header>
</template>

<script>
import tooltip from "../../../components/tooltip/tooltip";
import {forEach} from 'lodash';

export default {
    name: "navbar",
    components: {tooltip},
    data() {
        return {
            collapse: false,
            search: '',
            dropdowns: {
                search: false,
                notifications: false,
                profile: false,
            }
        }
    },
    methods: {
        /**
         * Abre e fecha a sidebar
         */
        toggleSidebar() {
            this.$store.commit('sidebar/toggleSidebar');
        },

        /**
         * Abre e fecha o menu no responsivo
         */
        toggleCollapse() {
            this.collapse = !this.collapse;
        },

        logout() {
            this.$store.dispatch('user/do_reset_user').then(() => {
                this.$store.commit('auth/destroyToken');
                this.$router.push('/');
            })
        },

        /**
         * Abre o menu correspondente e fecha os outros menus
         * @param payload - nome do menu a ser aberto
         */
        toggleDropdown(payload) {
            forEach(this.dropdowns, (value, key) => {
                if (key === payload) {
                    this.dropdowns[key] = !this.dropdowns[key];
                } else {
                    this.dropdowns[key] = false;
                }
            });
        },

        /**
         * Fecha todos os dropdowns
         */
        closeDropdowns() {
            forEach(this.dropdowns, (value, key) => {
                this.dropdowns[key] = false;
            });
        },

        /**
         * Realiza uma nova busca no sistema
         */
        buscar() {
            alert(this.search);
        }
    },
}
</script>

<style lang="scss" scoped>
.navbar {
    @apply w-full fixed top-0 left-0 right-0 z-40 flex items-center flex-wrap py-3 px-4
    bg-primary text-white shadow;
    height: 70px;

    .navbar-container {
        @apply w-full mx-4 flex justify-between;
    }

    .navbar-wrapper {
        @apply flex items-center;
    }

    .navbar-toggle {
        @apply py-2 pl-5 pr-4;

        &:focus {
            @apply outline-none;
        }
    }

    .navbar-breadcrumb {
        @apply py-3 mx-4 text-white;
    }

    .navbar-collapse {
        @apply absolute hidden flex-col items-start left-0 right-0
        px-3 bg-primary text-white;

        @media(min-width: 1024px) {
            @apply relative flex flex-row items-center mr-3 mt-0 left-auto right-auto px-0;
        }
    }

    .navbar-collapse.collapsed {
        @apply flex py-3;
        margin-top: 60px;

        @media(min-width: 1024px) {
            @apply mt-0 py-0;
        }
    }

    .navbar-search {
        @apply relative flex flex-row-reverse items-center py-2 ml-4;

        @media(min-width: 1024px) {
            @apply flex-row;
        }

        .navbar-search-button {
            @apply flex items-center;

            &:focus {
                @apply outline-none;
            }
        }

        //Oculta o texto de busca no responsivo
        .collapsed-search {
            @apply hidden ml-4;

            @media(min-width: 1024px) {
                @apply ml-3 block;
            }
        }

        .navbar-search-input {
            @apply block border border-gray-500 rounded-full py-1 px-8 ml-4 text-xs;

            @media(min-width: 1024px) {
                @apply mr-3 ml-0 text-sm;
            }

            &:focus {
                @apply outline-none border-primary;
            }
        }
    }

    .navbar-notifications {
        @apply relative flex flex-col justify-center items-start py-2 ml-4;

        @media(min-width: 1024px) {
            @apply flex-row items-center;
        }

        .navbar-notifications-button {
            @apply .flex .items-center;

            &:focus {
                @apply outline-none;
            }
        }

        .navbar-notifications-links {
            @apply relative block;

            @media(min-width: 1024px) {
                @apply absolute right-0 left-auto rounded z-50 py-2 px-0 text-light-gray bg-white mt-2;
                top: 50px;
                -webkit-box-shadow: 0 10px 50px 0 rgba(0, 0, 0, 2);
                box-shadow: 0 10px 50px 0 rgba(0, 0, 0, .2);
                transition: all 0.3s ease-out 0s;

                &:before {
                    @apply inline-block absolute w-0 h-0 align-middle text-white left-auto;
                    content: "";
                    top: -5px;
                    right: 30px;
                    border-bottom: .4em solid;
                    border-right: .4em solid transparent;
                    border-left: .4em solid transparent;
                }
            }

            .nav-link {
                @apply block px-2 text-sm;

                &:hover {
                    @apply bg-gray-200;
                }

                a {
                    @apply block w-full py-1 px-6 my-2 text-dark-gray whitespace-no-wrap;
                }

                &:hover {
                    @apply text-light-gray;
                }
            }

            .divider {
                @apply h-0 my-2 mx-0 overflow-hidden border-t border-gray-300;
            }
        }
    }

    .navbar-profile {
        @apply relative flex flex-col justify-center items-start py-2 ml-4;

        @media(min-width: 1024px) {
            @apply flex-row items-center;
        }

        .navbar-profile-button {
            @apply .flex .items-center;

            &:focus {
                @apply outline-none;
            }

            .navbar-profile-photo {
                @apply inline-block h-8 w-8 rounded-full overflow-hidden;
            }

            .navbar-profile-chevron {
                @apply hidden;

                @media(min-width: 1024px) {
                    @apply block ml-3;
                }
            }

            .navbar-profile-name {
                @apply block ml-3;

                @media(min-width: 1024px) {
                    @apply hidden;
                }
            }
        }

        .navbar-profile-links {
            @apply relative block;

            @media(min-width: 1024px) {
                @apply absolute right-0 left-auto rounded z-50 py-2 px-0 text-light-gray bg-white mt-2;
                top: 50px;
                -webkit-box-shadow: 0 10px 50px 0 rgba(0, 0, 0, .2);
                box-shadow: 0 10px 50px 0 rgba(0, 0, 0, .2);
                transition: all 0.3s ease-out 0s;

                &:before {
                    @apply inline-block absolute w-0 h-0 align-middle text-white left-auto;
                    content: "";
                    top: -5px;
                    right: 32px;
                    border-bottom: .4em solid;
                    border-right: .4em solid transparent;
                    border-left: .4em solid transparent;
                }
            }

            .nav-link {
                @apply block px-2 text-sm;

                &:hover {
                    @apply bg-gray-200;
                }

                a {
                    @apply block w-full py-1 px-6 my-2 text-dark-gray whitespace-no-wrap;
                }

                &:hover {
                    @apply text-light-gray;
                }
            }

            .divider {
                @apply h-0 my-2 mx-0 overflow-hidden border-t border-gray-300;
            }
        }

        .navbar-profile-links.active {
            @apply block;
        }

    }
}


</style>
